/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NqlQueryParamsDTO } from './NqlQueryParamsDTO';
import {
    NqlQueryParamsDTOFromJSON,
    NqlQueryParamsDTOFromJSONTyped,
    NqlQueryParamsDTOToJSON,
} from './NqlQueryParamsDTO';
import type { QueryLeaderboardParamsSortingParamsDTO } from './QueryLeaderboardParamsSortingParamsDTO';
import {
    QueryLeaderboardParamsSortingParamsDTOFromJSON,
    QueryLeaderboardParamsSortingParamsDTOFromJSONTyped,
    QueryLeaderboardParamsSortingParamsDTOToJSON,
} from './QueryLeaderboardParamsSortingParamsDTO';
import type { QueryLeaderboardParamsAttributeFilterDTO } from './QueryLeaderboardParamsAttributeFilterDTO';
import {
    QueryLeaderboardParamsAttributeFilterDTOFromJSON,
    QueryLeaderboardParamsAttributeFilterDTOFromJSONTyped,
    QueryLeaderboardParamsAttributeFilterDTOToJSON,
} from './QueryLeaderboardParamsAttributeFilterDTO';
import type { QueryLeaderboardParamsPaginationDTO } from './QueryLeaderboardParamsPaginationDTO';
import {
    QueryLeaderboardParamsPaginationDTOFromJSON,
    QueryLeaderboardParamsPaginationDTOFromJSONTyped,
    QueryLeaderboardParamsPaginationDTOToJSON,
} from './QueryLeaderboardParamsPaginationDTO';

/**
 * 
 * @export
 * @interface GlobalSearchParamsDTO
 */
export interface GlobalSearchParamsDTO {
    /**
     * 
     * @type {Array<QueryLeaderboardParamsAttributeFilterDTO>}
     * @memberof GlobalSearchParamsDTO
     */
    attributeFilters?: Array<QueryLeaderboardParamsAttributeFilterDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof GlobalSearchParamsDTO
     */
    experimentLeader?: boolean;
    /**
     * 
     * @type {QueryLeaderboardParamsPaginationDTO}
     * @memberof GlobalSearchParamsDTO
     */
    pagination?: QueryLeaderboardParamsPaginationDTO;
    /**
     * 
     * @type {NqlQueryParamsDTO}
     * @memberof GlobalSearchParamsDTO
     */
    query?: NqlQueryParamsDTO;
    /**
     * 
     * @type {QueryLeaderboardParamsSortingParamsDTO}
     * @memberof GlobalSearchParamsDTO
     */
    sorting?: QueryLeaderboardParamsSortingParamsDTO;
}

/**
 * Check if a given object implements the GlobalSearchParamsDTO interface.
 */
export function instanceOfGlobalSearchParamsDTO(value: object): value is GlobalSearchParamsDTO {
    return true;
}

export function GlobalSearchParamsDTOFromJSON(json: any): GlobalSearchParamsDTO {
    return GlobalSearchParamsDTOFromJSONTyped(json, false);
}

export function GlobalSearchParamsDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): GlobalSearchParamsDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'attributeFilters': json['attributeFilters'] == null ? undefined : ((json['attributeFilters'] as Array<any>).map(QueryLeaderboardParamsAttributeFilterDTOFromJSON)),
        'experimentLeader': json['experimentLeader'] == null ? undefined : json['experimentLeader'],
        'pagination': json['pagination'] == null ? undefined : QueryLeaderboardParamsPaginationDTOFromJSON(json['pagination']),
        'query': json['query'] == null ? undefined : NqlQueryParamsDTOFromJSON(json['query']),
        'sorting': json['sorting'] == null ? undefined : QueryLeaderboardParamsSortingParamsDTOFromJSON(json['sorting']),
    };
}

export function GlobalSearchParamsDTOToJSON(value?: GlobalSearchParamsDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'attributeFilters': value['attributeFilters'] == null ? undefined : ((value['attributeFilters'] as Array<any>).map(QueryLeaderboardParamsAttributeFilterDTOToJSON)),
        'experimentLeader': value['experimentLeader'],
        'pagination': QueryLeaderboardParamsPaginationDTOToJSON(value['pagination']),
        'query': NqlQueryParamsDTOToJSON(value['query']),
        'sorting': QueryLeaderboardParamsSortingParamsDTOToJSON(value['sorting']),
    };
}

